import { ProjectHubEntryFilterType } from '@/features/projects/projects-hub/components/project-hub-filter/project-hub-entry-filter-type';
import { ProjectStatus } from '@/features/projects/shared/types/project-status';
import { supabase } from '@/lib/supabase';
import { ProjectWithContractors } from '@/shared/types/api';
import { NotificationReadStatus } from '@/shared/types/filter/notification-filter-type';
import { formatDate } from '@/shared/utils/format';

export interface SubprojectFilters {
  statuses: ProjectStatus[] | undefined;
  partnerIds: string[] | undefined;
  notificationStatuses: NotificationReadStatus[] | undefined;
  lastEntry: ProjectHubEntryFilterType[] | undefined;
  searchQuery: string | undefined;
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
}

export const getFilteredProjectSubprojects = async ({
  projectId,
  filters,
}: {
  projectId: number;
  filters: SubprojectFilters;
}): Promise<ProjectWithContractors[]> => {
  const { data, error } = await supabase.rpc(
    'get_filtered_project_subprojects',
    {
      p_project_id: projectId,
      p_statuses: filters?.statuses,
      p_partners_ids: filters?.partnerIds,
      p_notification_types: filters?.notificationStatuses,
      p_last_entry_types: filters?.lastEntry,
      p_search_query: filters?.searchQuery,
      p_date_from: filters?.dateFrom
        ? formatDate({ date: filters.dateFrom, formatType: 'iso' })
        : undefined,
      p_date_to: filters?.dateTo
        ? formatDate({ date: filters.dateTo, formatType: 'iso' })
        : undefined,
    },
  );

  if (error) {
    throw error;
  }

  return (data ?? []) as ProjectWithContractors[];
};
